import request from "@/utils/request";

//获取系统用户列表
export async function userList(data) {
  return request({
    url: "/SysUser/List",
    method: "post",
    data: data,
  });
}

//系统用户添加
export async function userAdd(data) {
  return request({
    url: "/SysUser/Add",
    method: "post",
    data: data,
  });
}

//系统用户修改
export async function userUpdate(data) {
  return request({
    url: "/SysUser/SetUser",
    method: "post",
    data: data,
  });
}

//系统用户删除
export async function userDel(data) {
  return request({
    url: "/SysUser/DeleteUser",
    method: "post",
    params: data,
  });
}
